import { useTranslation } from 'react-i18next';
import { Page } from '@web/components/page';
import { PetCostsScreen, PetCostsScreenProps } from 'shared/screens/pet-costs';

export function PetCostsPage(props: PetCostsScreenProps) {
  const { t } = useTranslation('screens');

  return (
    <Page
      {...props}
      register={(seo) =>
        seo.forPage(
          t(`pet_costs.pages.${props.animal}.title`),
          t(`pet_costs.pages.${props.animal}.description`),
        )
      }
    >
      <PetCostsScreen {...props} />
    </Page>
  );
}
